import { apiUrl } from "@/lib/api-config";
import { apiFetch, getAuthHeaders } from "@/lib/api/client";

/**
 * Stores a reference file through the API.
 * A browser PUT to the presigned storage URL fails with "Failed to fetch"
 * when object storage does not answer the CORS preflight. That is the save
 * path after Summarize replaces a PDF with a text brief.
 */
export async function uploadKnowledgeDoc(
  file: File,
  folder: "contract-types" | "custom-roles"
): Promise<{ path: string; fileName: string }> {
  const form = new FormData();
  form.append("file", file);
  form.append("folder", folder);

  const response = await fetch(apiUrl("/api/knowledge-docs/upload"), {
    method: "POST",
    credentials: "include",
    headers: await getAuthHeaders(),
    body: form,
  });
  const data = (await response.json().catch(() => ({}))) as {
    path?: string;
    fileName?: string;
    error?: string;
  };

  if (!response.ok || !data.path || !data.fileName) {
    throw new Error(data.error || "Failed to upload knowledge document");
  }

  return { path: data.path, fileName: data.fileName };
}

export async function removeKnowledgeDoc(storagePath: string | null | undefined): Promise<void> {
  if (!storagePath) return;
  try {
    await apiFetch(`/api/knowledge-docs?path=${encodeURIComponent(storagePath)}`, {
      method: "DELETE",
    });
  } catch (err) {
    console.warn("[knowledge-docs] remove failed:", err);
  }
}

export async function getKnowledgeDocSignedUrl(
  storagePath: string | null | undefined
): Promise<string | null> {
  if (!storagePath) return null;
  try {
    const { downloadUrl } = await apiFetch<{ downloadUrl: string }>(
      `/api/storage/download-url?path=${encodeURIComponent(storagePath)}&bucket=knowledge-docs`
    );
    return downloadUrl;
  } catch {
    return null;
  }
}
